import type { Language } from '@offer-catalog/services/i18n/i18n.service'
import type { Brand } from '@/api/ddfs/ddfs'
import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { fetchDdfsCollection } from '@/api/ddfs/ddfs'
import { queryKeys } from '@/query/queryKeys'
import { DataFallback } from './DataFallback'

export function ProductBrand({ id }: Readonly<{ id?: string }>) {
  const { i18n, t } = useTranslation()
  const currentLanguage = i18n.language.split('-')[0] as Language

  const { data, isError, isLoading } = useQuery({
    enabled: Boolean(Number(id)),
    queryKey: queryKeys.brands(id, currentLanguage),
    queryFn: async () => {
      return await fetchDdfsCollection<Brand>('brands', { 'id[]': [id as string] }, currentLanguage)
    },
  })

  return (
    <div className="model-brand" data-testid="model_brand">
      <span className="sr-only">
        {t('products-page.filters.groups.brands')}
        :
        {' '}
      </span>
      <DataFallback
        value={data?.items[0]?.name}
        fallbackKey="products-page.product-card.no-brand"
        isLoading={isLoading && Boolean(id)}
        isError={isError}
      >
        {name => name}
      </DataFallback>
    </div>
  )
}
